/* eslint-disable react/no-array-index-key */
import FulfilledTitle from '@assets/fulfilled-title.svg';
import UnfulfilledTitle from '@assets/unfulfilled-title.svg';
import {
  PageTitle,
  BottomButtons,
  Panel, PackageCheckboxGroup, CheckBoxItem, ModalForNoTrackNumber,
} from '@components';
import {
  ClaimType, ShipmentStatus, PLATFORM_NAME, NEED_TO_ADD_TRACKING_NUMBER,
} from '@constants';
import { usePackageCheckbox } from './hooks';

import classes from '../choose/index.module.css';

const TextConfig = {
  Title: 'Protected item(s)',
  SubTitle: {
    [ClaimType.Damage]: 'Please choose which item(s) are damaged.',
    [ClaimType.Loss]: 'Please choose which item(s) are lost.',
  },

};

export const CheckPage = () => {
  const {
    fulfilledItems,
    unFulfilledItems,
    orderName,
    type,
    platform,
    isContinueBtnDisable,
    selectedItems,
    open,
    specialPlatform,
    fulfillmentInfo,
    currentPolicy,
    getTipsText,
    onClickContinue,
    handleChange,
    clearItems,
    handleClose,
    handleOK,
    handleShippingClick,
  } = usePackageCheckbox();
  // const hasTheft = policyList.find((item) => item.policyId === policyId)?.liabilities?.filter((v) => v.code === ClaimType.Theft)?.length > 0;
  const isNeedToAddTracking = NEED_TO_ADD_TRACKING_NUMBER.includes(specialPlatform);

  const getFulfilledBlock = () => {
    if (!fulfilledItems?.length) {
      return null;
    }
    // 以后平台如果有theft，不用再增加平台配置了，这里为了对所有有theft案件的订单都做了判断 注意：GARMENTORY特殊，接口没有返回liablilities
    const { liabilitiesArr } = currentPolicy;
    // 有theft时，如果送达了就不许报loss，引导去报theft
    const haveTheft = [PLATFORM_NAME.GARMENTORY, PLATFORM_NAME.GOODWILLFINDS, PLATFORM_NAME.SHOPPREMIUMOUTLETS, PLATFORM_NAME.SHOPSHOPS].includes(platform) || liabilitiesArr.includes(ClaimType.Theft);
    return (
      <Panel icon={FulfilledTitle} title="Fulfilled" className={classes.ful_panel}>
        {
          fulfilledItems.map((packageItem, packageIndex) => (
            <PackageCheckboxGroup
              key={packageItem.fulfillmentId + packageIndex}
              orderName={orderName}
              packageItem={packageItem}
              packageIndex={packageIndex}
              selectedItems={selectedItems}
              onChange={handleChange}
              disabled={(type === ClaimType.Damage && (([ShipmentStatus.UnDelivered, ShipmentStatus.Pending, ShipmentStatus.unDelivered].includes(packageItem.status)) || (isNeedToAddTracking && !packageItem.trackingNumber)))
                || (type === ClaimType.Loss && haveTheft && packageItem.status === ShipmentStatus.Delivered)}
              disabledText={getTipsText()}
              type={type}
              platform={platform}
              needAddShipping={(!packageItem.trackingNumber && isNeedToAddTracking) && <div className={classes.add_shipping} onClick={() => handleShippingClick(packageItem.fulfillmentId)}>Add Shipping Information</div>}// 只有指定平台才能补充trackingNumber
              haveTheft={haveTheft}
            />
          ))
        }
      </Panel>
    );
  };

  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }
    return (
      <Panel
        icon={UnfulfilledTitle}
        title="Unfulfilled"
        className={classes.unful_panel}
        needAddShipping={isNeedToAddTracking && <div className={classes.add_shipping} onClick={() => handleShippingClick('', true)}>Add Shipping Information</div>}
      >
        {
          unFulfilledItems.map((item, index) => (
            <CheckBoxItem
              key={item.lineItemId}
              item={item}
              index={index}
              disabled

            />
          ))
        }
      </Panel>
    );
  };

  return (
    <section className={classes.content}>
      <PageTitle title={TextConfig.Title} subTitle={TextConfig.SubTitle[type]} />
      {getFulfilledBlock()}
      {getUnfulfilledBlock()}
      <BottomButtons
        onClickBack={clearItems}
        isContinueDisabled={isContinueBtnDisable}
        onClickContinue={onClickContinue}
      />
      {open && (
        <ModalForNoTrackNumber
          open={open}
          handleClose={handleClose}
          handleOK={handleOK}
          currentFulfillmentId={fulfillmentInfo.fulfillmentId}
        />
      )}
    </section>
  );
};
